export class UserStatements {
  totalAmount = 0;
  totalCashbackAmount = 0;
  indicatorCredits = 0;
  indicatorCreditsOnHold = 0;
}
